export default {
  brand: {
    name: 'Helper Casino'
  },
  nav: {
    home: '首页',
    live: '真人',
    slots: '老虎机',
    sports: '体育',
    minigames: '迷你游戏',
    mini: '迷你',
    fishing: '捕鱼',
    mypage: '我的页面',
    deposit: '充值',
    withdraw: '提现',
    event: '活动',
    notice: '公告',
    support: '客服中心',
    slip: '站内信',
    betting: '投注记录',
    login: '登录',
    logout: '退出登录',
    signup: '注册',
    menuOpen: '打开菜单',
    menuClose: '关闭菜单',
    telegramInquiry: 'Telegram 咨询',
    mobilePrimary: '主要菜单'
  },
  maintenance: {
    title: '维护公告',
    defaultMessage: '网站正在维护中，请稍后再试。'
  },
  common: {
    close: '关闭',
    confirm: '确认',
    backToList: '返回列表',
    loading: '加载中...',
    refresh: '刷新',
    balanceRefresh: '刷新余额',
    prev: '上一页',
    next: '下一页',
    copySuccess: '复制成功。',
    copyFail: '复制失败。',
    telegramMissing: '暂无 Telegram 联系方式。',
    siteLoadError: '无法加载站点信息。',
    alertTitle: '提示',
    empty: '暂无数据。',
    noTitle: '（无标题）'
  },
  auth: {
    loginTitle: '登录',
    signupTitle: '注册',
    signupDesc: '请填写以下信息完成注册。',
    loginId: '用户名',
    loginIdPlaceholder: '用户名',
    password: '密码',
    passwordPlaceholder: '密码',
    passwordShow: '显示密码',
    passwordHide: '隐藏密码',
    loginSubmit: '登录',
    loginSubmitting: '登录中...',
    loginEmptyError: '请输入用户名和密码。',
    loginFail: '登录失败。',
    loginSuccess: '登录成功。',
    logoutSuccess: '已退出登录。',
    accountUnavailable: '无法使用此账户。',
    wrongCredentials: '用户名或密码不正确。',
    accountNotApproved: '账户尚未通过审核。',
    sessionExpired: '登录已过期。',
    sessionInvalid: '登录信息无效。',
    sessionNotFound: '未找到登录信息，请重新登录。',
    sessionDoubleLogin: '您的账户在其他设备登录，已退出当前会话。',
    sessionNetwork: '无法连接服务器，请重新登录。',
    signupPrompt: '快速注册即可开始游戏。',
    signupLink: '立即注册',
    nickname: '昵称',
    nicknamePlaceholder: '2~12 个字符',
    loginIdRulePlaceholder: '4~12 位英文或数字',
    passwordRulePlaceholder: '4~20 位',
    passwordConfirm: '确认密码',
    passwordConfirmPlaceholder: '再次输入密码',
    phone: '手机号码',
    sendCode: '发送验证码',
    resendCode: '重新发送',
    confirmCode: '验证',
    codePlaceholder: '6 位验证码',
    referralCode: '推荐码',
    referralCodePlaceholder: '请输入推荐码',
    referralHint: '如不知推荐人 ID，请',
    referralHintSuffix: '联系我们。',
    signupSubmit: '注册',
    signupSubmitting: '注册处理中...',
    hasAccount: '已有账号？',
    goLogin: '去登录',
    phoneVerified: '手机验证已完成。',
    phoneNeedVerify: '请完成手机验证。',
    phoneInvalid: '请检查手机号码。',
    phoneSendFail: '验证码发送失败。',
    phoneVerifyFail: '验证码不正确。',
    phoneNeedCode: '请先发送验证码。',
    errorLoginIdRequired: '请输入用户名。',
    errorLoginIdFormat: '用户名须为 4~12 位英文或数字。',
    errorNicknameRequired: '请输入昵称。',
    errorNicknameLength: '昵称须为 2~12 个字符。',
    errorPasswordRequired: '请输入密码。',
    errorPasswordLength: '密码须为 4~20 位。',
    errorPasswordConfirmRequired: '请确认密码。',
    errorPasswordMismatch: '两次输入的密码不一致。',
    errorReferralRequired: '请输入推荐码。',
    errorReferralInvalid: '请检查推荐码。',
    errorDuplicateLoginId: '该用户名已被使用。',
    errorDuplicateNickname: '该昵称已被使用。',
    errorDuplicateIp: '该 IP 已注册过账号。',
    signupFail: '注册失败。',
    signupSuccess: '注册成功。',
    signupSuccessLogin: '注册完成，请登录。'
  },
  games: {
    hotTitle: '热门游戏',
    providersTitle: '游戏供应商',
    hotProvidersTitle: '热门供应商',
    hotProvidersSubtitle: '选择供应商可进入老虎机列表或真人游戏大厅。',
    liveTitle: '真人',
    liveSubtitle: '选择供应商后登录即可进入大厅。',
    slotsTitle: '老虎机',
    slotsSubtitle: '选择供应商即可无需登录浏览游戏列表。',
    sportsTitle: '体育',
    sportsSubtitle: '体育投注',
    minigameTitle: '迷你游戏',
    fishingTitle: '捕鱼',
    list: '游戏列表',
    search: '搜索游戏',
    searchPlaceholder: '输入关键词',
    loading: '正在加载游戏...',
    loadingProviders: '正在加载供应商...',
    loadingSports: '正在加载体育...',
    empty: '暂无游戏。',
    emptyProviders: '暂无供应商。',
    emptySearch: '无搜索结果。',
    expand: '展开更多',
    collapse: '收起',
    play: '开始游戏',
    demo: '免费试玩',
    previewTagline: '立即游戏或免费试玩。',
    gameCountFiltered: '{shown} / 共 {total}',
    gameCountTotal: '共 {total} 款游戏',
    sportsPreparing: '体育游戏准备中。',
    loadError: '无法加载游戏列表。',
    launchError: '游戏启动失败。',
    demoError: '试玩启动失败。',
    sportsLaunchError: '体育游戏启动失败。',
    providerNotFound: '无法获取供应商信息。',
    providerNotFoundSports: '未找到体育供应商 {provider}。',
    providerNotFoundMinigame: '未找到供应商 {provider}。',
    categorySlot: '老虎机',
    categoryLive: '真人',
    categoryFishing: '捕鱼',
    categoryMini: '迷你',
    categorySports: '体育',
    categoryAll: '全部',
    categoryOther: '其他'
  },
  jackpot: {
    title: '超级累积奖池',
    mega: 'MEGA',
    live: 'LIVE · 实时累积'
  },
  popup: {
    aria: '弹窗公告',
    hide24h: '24 小时内不再显示',
    close: '关闭',
    closeAll: '关闭全部弹窗'
  },
  slip: {
    title: '站内信',
    desc: '查看收到的站内信。',
    loading: '正在加载站内信...',
    emptyAll: '暂无站内信。',
    emptyUnread: '暂无未读站内信。',
    emptyRead: '暂无已读站内信。',
    loadError: '无法加载站内信列表。',
    reload: '刷新',
    reloadAria: '刷新站内信列表',
    filterAria: '站内信筛选',
    prevPage: '上一页',
    nextPage: '下一页',
    colNo: '编号',
    colStatus: '状态',
    colTitle: '标题',
    colDate: '日期',
    noTitle: '（无标题）',
    unreadCount: '未读 {count} 条',
    unreadAria: '未读站内信 {count} 条',
    headerNotice: '您有未读站内信。',
    headerNoticeAria: '查看未读站内信',
    filterAll: '全部',
    filterUnread: '未读',
    filterRead: '已读',
    statusUnread: '未读',
    statusRead: '已读',
    detailLoadError: '无法加载站内信内容。',
    detailDefaultTitle: '站内信',
    unreadCheckMessage: '请查看未读站内信。',
    unreadCheckConfirm: '查看站内信'
  },
  support: {
    title: '客服中心',
    desc: '提交新咨询并查看咨询记录。',
    composeTitle: '提交咨询',
    fieldTitle: '标题',
    fieldTitlePlaceholder: '请输入咨询标题',
    fieldContent: '内容',
    fieldContentPlaceholder: '请输入咨询内容',
    submit: '提交咨询',
    submitting: '提交中...',
    historyTitle: '咨询记录',
    historyReloadAria: '刷新咨询记录',
    loading: '正在加载咨询记录...',
    loadError: '无法加载咨询记录。',
    empty: '暂无咨询记录。',
    colNo: '编号',
    colStatus: '状态',
    colTitle: '标题',
    colDate: '日期',
    statusAnswered: '已回复',
    statusPending: '待回复',
    errorTitleRequired: '请输入标题。',
    errorContentRequired: '请输入内容。',
    submitFail: '咨询提交失败。',
    submitSuccess: '咨询已提交。',
    detailDefaultTitle: '咨询详情',
    detailQuestionTitle: '咨询内容',
    detailAnswerTitle: '回复',
    detailAnswerPending: '等待回复中。',
    detailLoadError: '无法加载咨询详情。'
  },
  notice: {
    title: '公告',
    eventTitle: '活动',
    tabNotice: '公告',
    tabPopup: '弹窗公告',
    categoryNotice: '公告',
    categoryPopup: '弹窗',
    categoryEvent: '活动',
    priority: '重要',
    colNo: '编号',
    colCategory: '分类',
    colTitle: '标题',
    loadingNotice: '正在加载公告...',
    loadingEvent: '正在加载活动...',
    emptyNotice: '暂无公告。',
    emptyEvent: '暂无活动。',
    errorNotice: '无法加载公告。',
    errorEvent: '无法加载活动。',
    detailDefaultTitle: '公告',
    detailLoadError: '无法加载公告内容。'
  },
  betting: {
    title: '投注记录',
    desc: '查看最近的游戏投注记录。',
    startDate: '开始日期',
    endDate: '结束日期',
    gameName: '游戏名称',
    gameNamePlaceholder: '搜索游戏名称',
    search: '查询',
    totalBet: '总投注',
    totalWin: '总中奖',
    profit: '盈亏',
    loading: '正在加载投注记录...',
    loadError: '无法加载投注记录。',
    empty: '暂无投注记录。',
    colDateTime: '时间',
    colProvider: '供应商',
    colGameName: '游戏',
    colCategory: '分类',
    colBetAmount: '投注额',
    colWinAmount: '中奖额',
    colPreBalance: '投注前',
    colAfterBalance: '投注后',
    categorySlot: '老虎机',
    categoryLive: '真人',
    categoryFishing: '捕鱼',
    categoryMini: '迷你',
    categorySports: '体育',
    categoryAll: '全部',
    categoryOther: '其他',
    errorNoLogin: '登录信息已失效，请重新登录。',
    errorNoDateRange: '请选择查询日期范围。',
    errorDateRange: '开始日期不能晚于结束日期。'
  },
  mypage: {
    title: '我的页面',
    desc: '查看会员信息与账户资产。',
    loading: '正在加载会员信息...',
    loadError: '无法加载会员信息。',
    profileTitle: '会员信息',
    walletTitle: '账户资产',
    inquiryTitle: '1对1 咨询',
    inquiryDesc: '客服咨询记录',
    bettingTitle: '投注记录',
    bettingDesc: '最近游戏投注记录',
    loginId: '用户名',
    memberLevel: '会员等级',
    name: '姓名',
    phone: '手机号',
    referralCode: '推荐码',
    referralCodeEmpty: '无',
    bankHolder: '户名',
    bankName: '银行',
    bankAccount: '账号',
    joinDate: '注册日期',
    lastLogin: '最近登录',
    balance: '余额',
    bonus: '红利金额',
    apiBalance: '游戏联动余额',
    point: '积分',
    accountStatus: '账户状态',
    lastDepositDate: '最近充值',
    lastBetDate: '最近投注',
    deposit: '充值',
    withdraw: '提现',
    pointConvert: '积分转换',
    goTo: '前往',
    pointConvertTitle: '积分转换',
    pointConvertLoading: '正在加载余额信息...',
    pointConvertAmount: '转换积分',
    pointConvertAmountPlaceholder: '请输入转换积分',
    pointConvertAll: '全部',
    pointConvertSubmit: '积分转换为余额',
    pointConvertSubmitting: '转换中...',
    pointConvertNote1: '将积分转换为余额。',
    pointConvertNote2: '提交后立即生效。',
    pointConvertLoadError: '无法加载余额信息。',
    pointConvertAmountRequired: '请输入转换积分。',
    pointConvertAmountExceed: '转换金额不能超过可用积分。',
    pointConvertFail: '积分转换失败。',
    pointConvertSuccess: '积分转换成功。'
  },
  member: {
    role1: '管理员',
    role2: '总代理',
    role3: '代理',
    role4: '根代理',
    role5: '玩家',
    role6: 'BBS',
    role7: 'CP',
    role8: 'MJ',
    role9: '普通会员',
    levelTemplate: '{level} 级',
    statusNormal: '正常',
    statusSuspended: '停用'
  },
  wallet: {
    depositTitle: '充值',
    withdrawTitle: '提现',
    depositTabBank: '银行充值',
    depositTabTether: 'USDT 充值',
    withdrawTabBank: '银行提现',
    withdrawTabTether: 'USDT 提现',
    depositTabAria: '充值方式',
    withdrawTabAria: '提现方式',
    subtitleBoth: '可通过银行转账或 USDT（泰达币）进行充提。',
    subtitleTether: '可通过 USDT（泰达币）进行充提。',
    subtitleBank: '可通过银行转账进行充提。',
    tetherDepositGuideTitle: 'USDT 充值说明',
    bankDepositGuideTitle: '银行充值说明',
    bankWithdrawGuideTitle: '银行提现说明',
    tetherWithdrawGuideTitle: 'USDT 提现说明',
    tetherDepositGuideParagraph1: '如需使用 USDT（泰达币）充值，请在下方输入金额和您的钱包地址后提交充值申请。',
    tetherDepositGuideParagraph2: '提交后请转账至系统提供的 USDT 地址（TRC20），将按 Bithumb USDT 汇率折算并入账韩元金额。',
    tetherDepositGuideParagraph3Prefix: '地址或二维码相关咨询请联系 ',
    tetherDepositGuideParagraph3Suffix: ' 或客服中心。',
    bankDepositGuideParagraph1: '如需银行充值，请输入充值金额及账户信息（银行名称、汇款人姓名、账号）后提交申请。',
    bankDepositGuideParagraph2: '提交后请转账至系统提供的专用充值账户，系统将进行确认与处理。',
    bankDepositGuideParagraph3: '若使用他人名义或金额不一致，确认可能延迟。请务必按申请金额准确转账。',
    bankWithdrawGuideParagraph1: '银行提现请填写提现金额、银行名称、户名和账号后提交申请。',
    bankWithdrawGuideParagraph2Prefix: '请确认您填写的账户信息准确无误。如需咨询，请联系 ',
    bankWithdrawGuideParagraph2Suffix: '。',
    tetherWithdrawGuideParagraph1: 'USDT（泰达币）提现请填写提现金额和 USDT 地址（TRC20）后提交申请。',
    tetherWithdrawGuideParagraph2Prefix: '如需咨询提现流程或 USDT 地址，请联系 ',
    tetherWithdrawGuideParagraph2Suffix: '。',
    tetherDepositRequestTitle: 'USDT 充值申请',
    bankDepositRequestTitle: '银行充值申请',
    bankWithdrawRequestTitle: '银行提现申请',
    tetherWithdrawRequestTitle: 'USDT 提现申请',
    depositAmountLabel: '充值金额',
    withdrawAmountLabel: '提现金额',
    amountPlaceholder: '例：100,000 韩元',
    quick10k: '1 万',
    quick30k: '3 万',
    quick50k: '5 万',
    quick100k: '10 万',
    quick500k: '50 万',
    reset: '重置',
    required: '必填',
    checking: '确认中...',
    requesting: '请求中...',
    walletAddressLabel: '我的钱包地址',
    walletAddressPlaceholder: '请输入钱包地址',
    walletCheck: '验证钱包',
    walletBalanceLabel: '持有币种',
    walletBalanceUnit: 'USDT',
    walletCheckHintDeposit: '充值前请点击验证钱包，确认 TRC20 USDT 余额。',
    walletCheckHintWithdraw: '提现前请点击验证钱包，确认 TRC20 USDT 余额。',
    tetherAddressLabel: 'USDT 地址',
    tetherAddressPlaceholder: '请输入 USDT（泰达币）TRC20 提现地址',
    bankInfoGroup: '银行账户信息',
    bankNameLabel: '银行名称',
    bankNamePlaceholder: '例：国民银行',
    depositorNameLabel: '汇款人姓名',
    depositorNamePlaceholder: '汇款人姓名',
    accountHolderLabel: '户名',
    accountHolderPlaceholder: '真实姓名',
    accountNumberLabel: '账号',
    accountNumberPlaceholder: '仅输入数字，不含连字符',
    availableBalanceLabel: '可提现金额',
    checkAvailableBalance: '查看可提现金额',
    depositRequest: '申请充值',
    withdrawRequest: '申请提现',
    supportInquiry: '联系客服',
    tetherAddressGuide: 'USDT 地址说明',
    networkTrc20: 'TRC20',
    networkHint: '请仅通过 TRC20（波场）网络充值。',
    requestedAmount: '申请金额：{amount} USDT',
    qrAlt: 'USDT 充值二维码',
    qrLoading: '生成二维码中...',
    qrCaption: '扫描 TRC20 二维码充值',
    copyAddress: '复制地址',
    copiedAddress: '已复制',
    addressCopied: '地址已复制。',
    tetherAddressCopied: 'USDT 地址已复制。',
    addressCopyFail: '地址复制失败。',
    copyBankName: '复制银行名称',
    copyAccountNo: '复制账号',
    copyHolder: '复制户名',
    bankAccountGuide: '充值账户说明',
    bankDepositHint: '请向以下账户汇入 {amount}。',
    bankName: '银行',
    accountNumber: '账号',
    accountHolder: '户名',
    depositHistoryTitle: '充值记录',
    withdrawHistoryTitle: '提现记录',
    historyDesc: '显示申请中、已完成等全部记录。',
    historyReloadDeposit: '刷新充值记录',
    historyReloadWithdraw: '刷新提现记录',
    loadingDepositHistory: '正在加载充值记录...',
    loadingWithdrawHistory: '正在加载提现记录...',
    loadDepositHistoryError: '无法加载充值记录。',
    loadWithdrawHistoryError: '无法加载提现记录。',
    emptyDepositHistory: '暂无充值记录。',
    emptyWithdrawHistory: '暂无提现记录。',
    colRequestDate: '申请时间',
    colType: '类型',
    colAmount: '金额',
    colDepositInfo: '充值信息',
    colWithdrawInfo: '提现信息',
    colMemo: '备注',
    colStatus: '状态',
    colProcessedDate: '处理时间',
    statusRequest: '已申请',
    statusWaiting: '等待中',
    statusComplete: '已完成',
    statusCancel: '已取消',
    statusDelete: '已删除',
    statusUnknown: '未知',
    chargeTypeNormal: '普通充值申请',
    chargeTypeForce: '强制充值',
    chargeTypeOther: '其他',
    withdrawTypeNormal: '普通提现',
    withdrawTypeForce: '强制提现',
    withdrawTypeOther: '其他',
    depositMinAmount: '充值金额须不少于 {amount}。',
    depositWalletRequired: '请输入钱包地址。',
    depositWalletCheckRequired: '请先完成钱包验证后再申请充值。',
    depositRateLoading: '正在加载 USDT 汇率，请稍后再试。',
    depositSuccess: '充值申请已提交。',
    depositFail: '充值申请失败，请稍后再试。',
    depositPending: '已有充值申请处理中，请等待完成后再申请。',
    bankNameRequired: '请输入银行名称。',
    depositorRequired: '请输入汇款人姓名。',
    accountRequired: '请输入账号。',
    invalidTronAddress: '请输入有效的 TRC20 钱包地址。',
    walletBalanceFail: '钱包余额查询失败。',
    walletBalanceNetworkFail: '钱包余额查询失败，请检查网络连接。',
    depositNoteMismatch: '实际汇款金额与申请金额不符时，确认可能延迟。',
    withdrawMinAmount: '提现金额须不少于 {amount}。',
    withdrawBalanceLoading: '正在加载可提现金额，请稍后再试。',
    withdrawExceedAvailable: '提现金额超过可提现余额（{amount}）。',
    withdrawExceedBalance: '提现金额超过可提现余额，请查看提现规则（流水要求及红利扣除）。',
    withdrawPending: '已有提现申请处理中，请等待完成后再申请。',
    withdrawLimitMinutes: '提现申请间隔为 {minutes} 分钟，请稍后再试。',
    withdrawLimitGeneric: '提现冷却时间未到，请稍后再试。',
    withdrawSuccess: '提现申请已提交。',
    withdrawFail: '提现申请失败，请稍后再试。',
    tetherAddressRequired: '请输入 USDT 地址。',
    withdrawWalletCheckRequired: '请先完成钱包验证后再申请提现。',
    holderRequired: '请输入户名。',
    availableModalTitle: '可提现金额说明',
    availableModalLabel: '当前可提现金额',
    refreshBalance: '刷新金额',
    amountInfoTitle: '金额明细',
    amountInfoAria: '可提现金额计算说明',
    totalDeposit: '总充值',
    totalBet: '总投注',
    requiredBet: '所需流水（总充值 × {percent}）',
    heldMoney: '余额',
    heldBonus: '红利余额',
    withdrawRule: '提现规则',
    formula: '计算公式',
    rulesTitle: '提现规则说明',
    ruleMetSummary: '流水已达标 — 可全额提现',
    ruleNotMetSummary: '流水未达标 — 扣除红利后提现',
    formulaCalculating: '正在计算可提现金额',
    ruleInfoLoading: '正在加载提现规则...',
    conditionChecking: '正在检查提现条件...',
    conditionLoadFail: '无法加载提现条件。',
    conditionMet: '当前总投注（{totalBet}）已超过所需流水（{requiredBet}），可全额提现。',
    conditionNotMet: '当前总投注（{totalBet}）未达所需流水（{requiredBet}），可提现金额为余额减去红利。',
    ruleBetMetTitle: '流水已达标',
    ruleBetMetDesc: '总投注超过总充值 × {percent} 时，可申请全额提现。',
    ruleBetNotMetTitle: '流水未达标',
    ruleBetNotMetDesc: '总投注未达标准时，可提现金额为余额减去红利。',
    ruleTotalDepositNote: '提现申请及处理时将扣除相应金额。',
    ruleTotalBetNote: '充值后至首次提现前累计的投注额，提现处理后重置为 0。',
    amountWon: '{amount} 韩元',
    rateLabel: 'Bithumb 1 USDT = {rate}',
    rateLive: '实时',
    rateConnectFail: 'Bithumb 汇率连接失败。',
    rateDisconnected: 'Bithumb 汇率连接已断开。',
    chargeMemo: '充值 {krw} = {usdt} USDT 申请',
    withdrawMemo: '提现 {krw} = {usdt} USDT 申请'
  },
  lang: {
    title: '语言设置',
    changed: '语言已更改。'
  },
  payment: {
    depositSubtitleBoth: '可通过银行转账或 USDT（泰达币）申请充值。',
    depositSubtitleTether: '可通过 USDT（泰达币）申请充值。',
    depositSubtitleBank: '可通过银行转账申请充值。',
    withdrawSubtitleBoth: '可通过银行转账或 USDT（泰达币）申请提现。',
    withdrawSubtitleTether: '可通过 USDT（泰达币）申请提现。',
    withdrawSubtitleBank: '可通过银行转账申请提现。'
  }
}
